// @flow

import type {
  AccountOperation,
  AccountOperator,
} from '../types'

// Login Operator
import operator from './operator'

// Module Export Type
type AccountReducers = { [string]: (state: Object, payload: AccountOperation) => Object }

// Reducers
function cancelOperation (state: Object): Object {
  return {
    ...state,
    accountOperation: [],
  }
}

function addOperation (state: Object, payload: AccountOperation): Object {
  return {
    ...state,
    accountOperation: payload,
  }
}

function updateOperation (state: Object, payload: AccountOperation): Object {
  if (state.accountOperation) {
    return {
      ...state,
      accountOperation: {
        ...payload,
        model: {
          ...state.accountOperation.model,
          ...payload.model,
        },
      },
    }
  } else {
    return {
      ...state,
      accountOperation: payload,
    }
  }
}

export default function composeAccountReducer (): AccountReducers {
  const accountOperator: AccountOperator = operator()

  return {
    [accountOperator.actionTypes.add()]: addOperation,
    [accountOperator.actionTypes.updateOperation()]: updateOperation,
    [accountOperator.actionTypes.cancelOperation()]: cancelOperation,
  }
}
